import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonText,
  IonTextarea,
  IonToast,
  useIonRouter,
} from "@ionic/react";
import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import {AuthContext} from "../../providers/authContext";
import userService from "../../services/UserService";
import "./Page.css";
import {EmlakBeyanBildirim} from "../entities/EmlakBeyanBildirim";
import Mahalle from "../entities/Mahalle";
import sorgulamaService from "../../services/SorgulamaService";
import Sokak from "../entities/Sokak";
import BinaInsaatTur from "../entities/BinaInsaatTur";
import BinaInsaatSinif from "../entities/BinaInsaatSinif";
import BinaKullanimSekli from "../entities/BinaKullanimSekli";
import BinaryData from "../entities/BinaryData";
import DateInput from "../../components/DateInput";

const BinaBildirim: React.FC = () => {
  const { authInfo, setTitle } = React.useContext(AuthContext);
  const navigation = useIonRouter();
  const [mahalleler, setMahalleler] = useState<Mahalle[]>([]);
  const [sokaklar, setSokaklar] = useState<Sokak[]>([]);
  const [insaatTurleri, setInsaatTurleri] = useState<BinaInsaatTur[]>([]);
  const [insaatSiniflari, setInsaatSiniflari] = useState<BinaInsaatSinif[]>([]);
  const [kullanimSekilleri, setKullanimSekilleri] = useState<
      BinaKullanimSekli[]
  >([]);
  const [emlak, setEmlak] = useState<EmlakBeyanBildirim>(new EmlakBeyanBildirim("1"));
  const [kimlikFile, setKimlikFile] = useState<any>();
  const [tapuFile, setTapuFile] = useState<any>();
  const [yapiRuhsatiFile, setYapiRuhsatiFile] = useState<any>();
  const [yapiKullanimIzinFile, setYapiKullanimIzinFile] = useState<any>();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string>();

  React.useEffect(() => {
    setTitle("Bina Bildirim İşlemi");
    sorgulamaService
        .getMahalleler()
        .then((data: Mahalle[]) => setMahalleler(data));
    sorgulamaService
        .getBinaInsaatTurleri()
        .then((data: BinaInsaatTur[]) => setInsaatTurleri(data))
        .catch((err) => {
          console.log("error on setInsaatTurleri on getBinaInsaatTurleri: ", err);
          setToastMessage(err);
        })
  }, []);
  useEffect(() => {
    if (emlak?.mahalleId) {
      sorgulamaService
          .getSokaklar(emlak.mahalleId)
          .then((data: Sokak[]) => setSokaklar(data));
    }
  }, [emlak?.mahalleId]);

  useEffect(() => {
    setShowLoading(true);
    setInsaatSiniflari([]);
    sorgulamaService
        .getBinaInsaatSiniflari(emlak?.beyanYili, emlak?.kullanimSekliId!)
        .then((data: BinaKullanimSekli[]) => setInsaatSiniflari(data))
        .finally(() => setShowLoading(false));
  }, [emlak?.beyanYili, emlak?.kullanimSekliId]);

  useEffect(() => {
    setShowLoading(true);
    setKullanimSekilleri([]);
    setInsaatSiniflari([]);
    sorgulamaService
        .getBinaKullanimSekilleri(emlak?.beyanYili)
        .then((data: BinaKullanimSekli[]) => setKullanimSekilleri(data))
        .finally(() => setShowLoading(false));
  }, [emlak?.beyanYili]);

  const kaydet = (event: any) => {
    event.preventDefault();
    if (!emlak.mahalleId || !emlak.sokakId) {
      setToastMessage("Mahalle / Caddde Sokak boş geçilemez!");
      return;
    }
    if (!emlak.adaNo || !emlak.parselNo) {
      setToastMessage("Ada veya Parsel No bilgileri boş geçilemez!");
      return;
    }
    if (!emlak.arsaAlani) {
      setToastMessage("Arsa Alanı boş geçilemez!");
      return;
    }
    if (!emlak.arsaAlaniPayi || Number(emlak.arsaAlaniPayi) <= 0 || !emlak.arsaAlaniPaydasi || Number(emlak.arsaAlaniPaydasi) <= 0) {
      setToastMessage("Arsa Payı Oranı boş geçilemez!");
      return;
    }
    if (!emlak.insaatTurId) {
      setToastMessage("İnşaat Türü boş geçilemez!");
      return;
    }
    if (!emlak.kullanimSekliId) {
      setToastMessage("Kullanım Şekli boş geçilemez!");
      return;
    }
    if (!emlak.insaatSinifId) {
      setToastMessage("İnşaat Sınıfı boş geçilemez!");
      return;
    }
    if (!emlak.insaatinBitimTarihi) {
      setToastMessage("İnşaatın Bitim Tarihi boş geçilemez!");
      return;
    }
    if (!emlak.iktisapTarihi) {
      setToastMessage("İktisap Tarihi boş geçilemez!");
      return;
    }
    if (!emlak.distanDisaM2 || Number(emlak.distanDisaM2) <= 0) {
      setToastMessage("Dıştan Dışa Yüzölçümü boş geçilemez!");
      return;
    }
    if (!emlak.hisseOraniPayi || Number(emlak.hisseOraniPayi) <= 0 || !emlak.hisseOraniPaydasi || Number(emlak.hisseOraniPaydasi) <= 0) {
      setToastMessage("Hisse Oranı boş geçilemez!");
      return;
    }
    if (!emlak.kimlikBelge || !emlak.kimlikBelge.data) {
      setToastMessage("Kimlik Belgesi eklenmelidir!");
      return;
    }
    if (!emlak.tapuBelge || !emlak.tapuBelge.data) {
      setToastMessage("Tapu Belgesi eklenmelidir!");
      return;
    }
    if (!emlak.yapiRuhsatBelge || !emlak.yapiRuhsatBelge.data) {
      setToastMessage("Yapı Ruhsatı Belgesi eklenmelidir!");
      return;
    }
    if (!emlak.yapiIzinBelge || !emlak.yapiIzinBelge.data) {
      setToastMessage("Yapı Kullanım İzin Belgesi eklenmelidir!");
      return;
    }

    setShowLoading(true);
    userService
      .emlakBildirimKaydet(emlak)
      .then(() => {
        (document as any).getElementById("kimlik-upload").value = "";
        setKimlikFile(null);
        (document as any).getElementById("tapu-upload").value = "";
        setTapuFile(null);
        (document as any).getElementById("yapi-ruhsati-upload").value = "";
        setYapiRuhsatiFile(null);
        (document as any).getElementById("yapi-izin-upload").value = "";
        setYapiKullanimIzinFile(null);
        setEmlak((prev) => new EmlakBeyanBildirim("1"));
        setToastMessage("İşleminiz başarılı bir şekilde tamamlanmıştır.");
        navigation.push("/page/EmlakBildirimSorgu?bildirimTipi=Normal&bildirimTuru=Bina", "forward");
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        setToastMessage(error.response ? error.response.data.message : error);
      })
      .finally(() => setShowLoading(false));
  };

  const handleNumericOnlyPress = (event: React.KeyboardEvent) => {
    // Prevent non-numeric input
    const charCode = event.charCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  return (
    <IonPage>
      <Header />
      <IonContent fullscreen>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={toastMessage !== undefined}
          onDidDismiss={() => setToastMessage(undefined)}
          message={toastMessage}
          duration={2000}
          position="top"
        />
        <form
          onSubmit={(e) => {
            kaydet(e);
          }}
        >
          <IonGrid>
            <IonRow>
              <IonCol
                size="4"
                offset="0"
                sizeSm="4"
                offsetSm="1"
                className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Bildirim tarihi</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Bildirim tarihi</IonLabel>
                  <IonInput
                      name="beyanTarihiInput"
                      value={emlak.beyanTarihi}
                      disabled
                  />
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="beyanTarihiInput"
                      value={emlak.beyanTarihi}
                      disabled
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Bulunduğu Köy veya Mahalle</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">
                    Bulunduğu Köy veya Mahalle
                  </IonLabel>
                  <IonSelect
                      name="mahInput"
                      interface="popover"
                      value={emlak.mahalleId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, mahalleId: e.detail.value! })
                      }
                  >
                    {mahalleler &&
                        mahalleler.map((val, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                      name="mahInput"
                      interface="popover"
                      value={emlak.mahalleId}
                      placeholder="Seçiniz..."
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, mahalleId: e.detail.value! })
                      }
                  >
                    {mahalleler &&
                        mahalleler.map((val, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Cadde veya Sokağı</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Cadde veya Sokağı</IonLabel>
                  <IonSelect
                      name="caddeInput"
                      interface="popover"
                      value={emlak.sokakId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, sokakId: e.detail.value! })
                      }
                  >
                    {sokaklar &&
                        sokaklar.map((val, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                      name="caddeInput"
                      interface="popover"
                      value={emlak.sokakId}
                      placeholder="Seçiniz..."
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, sokakId: e.detail.value! })
                      }
                  >
                    {sokaklar &&
                        sokaklar.map((val, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Blok No / Kat No</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonGrid className="ion-hide-sm-up ion-no-padding">
                  <IonRow className="ion-nowrap">
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Blok No</IonLabel>
                        <IonInput
                            name="blokNoInput"
                            value={emlak.blokNo}
                            maxlength={15}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  blokNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Kat No</IonLabel>
                        <IonInput
                            name="katNoInput"
                            value={emlak.katNo}
                            maxlength={15}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  katNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="blokNoInput"
                      value={emlak.blokNo}
                      maxlength={15}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, blokNo: e.detail.value! })
                      }
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="katNoInput"
                      value={emlak.katNo}
                      maxlength={15}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, katNo: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Kapı No / Daire No</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonGrid className="ion-hide-sm-up ion-no-padding">
                  <IonRow className="ion-nowrap">
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Kapı No</IonLabel>
                        <IonInput
                            name="kapiNoInput"
                            value={emlak.kapiNo}
                            maxlength={15}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  kapiNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Daire No</IonLabel>
                        <IonInput
                            name="daireNoInput"
                            value={emlak.bagNo}
                            maxlength={15}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  bagNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="kapiNoInput"
                      value={emlak.kapiNo}
                      maxlength={15}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, kapiNo: e.detail.value! })
                      }
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="daireNoInput"
                      value={emlak.bagNo}
                      maxlength={15}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, bagNo: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Pafta / Ada / Parsel No</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonGrid className="ion-hide-sm-up ion-no-padding">
                  <IonRow className="ion-nowrap">
                    <IonCol size="3">
                      <IonItem>
                        <IonLabel position="floating">Pafta No</IonLabel>
                        <IonInput
                            name="paftaNoInput"
                            value={emlak.paftaNo}
                            maxlength={10}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  paftaNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="3">
                      <IonItem>
                        <IonLabel position="floating">Ada No</IonLabel>
                        <IonInput
                            name="adaNoInput"
                            value={emlak.adaNo}
                            maxlength={10}
                            type="text"
                            inputmode="numeric"
                            onIonChange={(e) => {
                                if (Number.isFinite(e.detail.value)) {
                                  setEmlak({
                                    ...emlak,
                                    adaNo: e.detail.value!,
                                  })
                                }
                              }
                            }
                            onKeyPress={handleNumericOnlyPress}
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="3">
                      <IonItem>
                        <IonLabel position="floating">Parsel No</IonLabel>
                        <IonInput
                            name="parselNoInput"
                            value={emlak.parselNo}
                            maxlength={10}
                            type="text"
                            inputmode="numeric"
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  parselNo: e.detail.value!,
                                })
                            }
                            onKeyPress={handleNumericOnlyPress}
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="paftaNoInput"
                      value={emlak.paftaNo}
                      maxlength={10}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, paftaNo: e.detail.value! })
                      }
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="adaNoInput"
                      value={emlak.adaNo}
                      type="text"
                      inputmode="numeric"
                      maxlength={10}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, adaNo: e.detail.value! })
                      }
                      onKeyPress={handleNumericOnlyPress}
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="parselNoInput"
                      value={emlak.parselNo}
                      maxlength={10}
                      type="text"
                      inputmode="numeric"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, parselNo: e.detail.value! })
                      }
                      onKeyPress={handleNumericOnlyPress}
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Cilt / Sahife No</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonGrid className="ion-hide-sm-up ion-no-padding">
                  <IonRow className="ion-nowrap">
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Cilt No</IonLabel>
                        <IonInput
                            name="ciltNoInput"
                            value={emlak.ciltNo}
                            maxlength={15}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  ciltNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Sahife No</IonLabel>
                        <IonInput
                            name="sahifeNoInput"
                            value={emlak.sahifeNo}
                            maxlength={15}
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  sahifeNo: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="ciltNoInput"
                      value={emlak.ciltNo}
                      maxlength={15}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, ciltNo: e.detail.value! })
                      }
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="sahifeNoInput"
                      value={emlak.sahifeNo}
                      maxlength={15}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, sahifeNo: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Bina Arsa Alanı (m<sup>2</sup>)</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Bina Arsa Alanı (m<sup>2</sup>)</IonLabel>
                  <IonInput
                      name="arsaAlaniInput"
                      value={emlak.arsaAlani}
                      maxlength={20}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, arsaAlani: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="arsaAlaniInput"
                      value={emlak.arsaAlani}
                      maxlength={20}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, arsaAlani: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Bina Arsa Alanı Payı / Paydası</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonGrid className="ion-hide-sm-up ion-no-padding">
                  <IonRow className="ion-nowrap">
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Bina Arsa Alanı Payı</IonLabel>
                        <IonInput
                            name="arsaAlaniPayiInput"
                            value={emlak.arsaAlaniPayi}
                            maxlength={15}
                            type="number"
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  arsaAlaniPayi: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Bina Arsa Alanı Paydası</IonLabel>
                        <IonInput
                            name="arsaAlaniPaydasiInput"
                            value={emlak.arsaAlaniPaydasi}
                            maxlength={15}
                            type="number"
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  arsaAlaniPaydasi: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="arsaAlaniPayiInput"
                      value={emlak.arsaAlaniPayi}
                      maxlength={15}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, arsaAlaniPayi: e.detail.value! })
                      }
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="arsaAlaniPaydasiInput"
                      value={emlak.arsaAlaniPaydasi}
                      maxlength={15}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, arsaAlaniPaydasi: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>İnşaat Türü</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">İnşaat Türü</IonLabel>
                  <IonSelect
                      name="insaatTuruIdInput"
                      interface="popover"
                      value={emlak.insaatTurId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, insaatTurId: e.detail.value! })
                      }
                  >
                    {insaatTurleri?.map((val) => (
                        <IonSelectOption key={val.id} value={val.id}>
                          {val.tanim}
                        </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                      name="insaatTuruIdInput"
                      interface="popover"
                      placeholder="Seçiniz"
                      value={emlak.insaatTurId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, insaatTurId: e.detail.value! })
                      }
                  >
                    {insaatTurleri?.map((val) => (
                        <IonSelectOption key={val.id} value={val.id}>
                          {val.tanim}
                        </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Kullanım Şekli</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Kullanım Şekli</IonLabel>
                  <IonSelect
                      name="kullanimSekliIdInput"
                      interface="popover"
                      value={emlak.kullanimSekliId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, kullanimSekliId: e.detail.value! })
                      }
                  >
                    {kullanimSekilleri &&
                        kullanimSekilleri.map((val: BinaKullanimSekli, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                      name="kullanimSekliIdInput"
                      interface="popover"
                      value={emlak.kullanimSekliId}
                      placeholder="Seçiniz..."
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, kullanimSekliId: e.detail.value! })
                      }
                  >
                    {kullanimSekilleri &&
                        kullanimSekilleri.map((val: BinaKullanimSekli, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>İnşaat Sınıfı</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">İnşaat Sınıfı</IonLabel>
                  <IonSelect
                      name="insaatSinifiIdInput"
                      interface="popover"
                      value={emlak.insaatSinifId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, insaatSinifId: e.detail.value! })
                      }
                  >
                    {insaatSiniflari && insaatSiniflari.map &&
                        insaatSiniflari.map((val: BinaInsaatSinif, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                      name="insaatSinifiIdInput"
                      interface="popover"
                      value={emlak.insaatSinifId}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, insaatSinifId: e.detail.value! })
                      }
                      placeholder="Seçiniz..."
                  >
                    {insaatSiniflari && insaatSiniflari.map &&
                        insaatSiniflari.map((val: BinaInsaatSinif, i) => (
                            <IonSelectOption key={i} value={val.id}>
                              {val.tanim}
                            </IonSelectOption>
                        ))}
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>İnşaatın Bitim Tarihi</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="stacked">İnşaatın Bitim Tarihi</IonLabel>
                  <DateInput
                      title="İnşaatın Bitim Tarihi"
                      value={emlak.insaatinBitimTarihi}
                      onChange={(tar: string) => setEmlak({
                        ...emlak,
                        insaatinBitimTarihi: tar,
                      })}
                  />
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <DateInput
                      title="İnşaatın Bitim Tarihi"
                      value={emlak.insaatinBitimTarihi}
                      onChange={(tar: string) => setEmlak({
                        ...emlak,
                        insaatinBitimTarihi: tar,
                      })}
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>İktisap Tarihi</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="stacked">İktisap Tarihi</IonLabel>
                  <DateInput
                      title="İktisap Tarihi"
                      value={emlak.iktisapTarihi}
                      onChange={(tar: string) => setEmlak({
                        ...emlak,
                        iktisapTarihi: tar,
                      })}
                  />
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <DateInput
                      title="İktisap Tarihi"
                      value={emlak.iktisapTarihi}
                      onChange={(tar: string) => setEmlak({
                        ...emlak,
                        iktisapTarihi: tar,
                      })}
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Dıştan Dışa Yüzölçümü (m<sup>2</sup>)</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Dıştan Dışa Yüzölçümü (m<sup>2</sup>)</IonLabel>
                  <IonInput
                      name="distanDisaM2Input"
                      value={emlak.distanDisaM2}
                      maxlength={20}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, distanDisaM2: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="distanDisaM2Input"
                      value={emlak.distanDisaM2}
                      maxlength={20}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, distanDisaM2: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Hisse Oranı Payı / Paydası</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonGrid className="ion-hide-sm-up ion-no-padding">
                  <IonRow className="ion-nowrap">
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Hisse Oranı Payı</IonLabel>
                        <IonInput
                            name="hisseOraniPayiInput"
                            value={emlak.hisseOraniPayi}
                            maxlength={15}
                            type="number"
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  hisseOraniPayi: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                    <IonCol size="1">
                      <IonItem className="ion-padding-start ion-padding-end">
                        <IonText>-</IonText>
                      </IonItem>
                    </IonCol>
                    <IonCol size="4">
                      <IonItem>
                        <IonLabel position="floating">Hisse Oranı Paydası</IonLabel>
                        <IonInput
                            name="hisseOraniPaydasiInput"
                            value={emlak.hisseOraniPaydasi}
                            maxlength={15}
                            type="number"
                            onIonChange={(e) =>
                                setEmlak({
                                  ...emlak,
                                  hisseOraniPaydasi: e.detail.value!,
                                })
                            }
                            clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonGrid>
                <IonItem className="ion-hide-sm-down">
                  <IonInput
                      name="hisseOraniPayiInput"
                      value={emlak.hisseOraniPayi}
                      maxlength={15}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, hisseOraniPayi: e.detail.value! })
                      }
                      clearInput
                  />
                  <IonText className="ion-padding-start ion-padding-end">
                    /
                  </IonText>
                  <IonInput
                      name="hisseOraniPaydasiInput"
                      value={emlak.hisseOraniPaydasi}
                      maxlength={15}
                      type="number"
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, hisseOraniPaydasi: e.detail.value! })
                      }
                      clearInput
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Kaloriferli Mi?</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="fixed">Kaloriferli Mi?</IonLabel>
                  <IonCheckbox
                    color="primary"
                    checked={emlak.kaloriferli}
                    slot="start"
                    onIonChange={(e) => setEmlak({ ...emlak, kaloriferli: e.detail.checked })}
                ></IonCheckbox>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonCheckbox
                      color="primary"
                      checked={emlak.kaloriferli}
                      slot="start"
                      onIonChange={(e) => setEmlak({ ...emlak, kaloriferli: e.detail.checked })}
                  ></IonCheckbox>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Asansörlü Mü</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="fixed">Asansörlü Mü</IonLabel>
                  <IonCheckbox
                      color="primary"
                      checked={emlak.asansorlu}
                      slot="start"
                      onIonChange={(e) => setEmlak({ ...emlak, asansorlu: e.detail.checked })}
                  ></IonCheckbox>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonCheckbox
                      color="primary"
                      checked={emlak.asansorlu}
                      slot="start"
                      onIonChange={(e) => setEmlak({ ...emlak, asansorlu: e.detail.checked })}
                  ></IonCheckbox>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                  size="4"
                  offset="0"
                  sizeSm="4"
                  offsetSm="1"
                  className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end ion-margin-top">
                  <IonLabel>Açıklama</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Açıklama</IonLabel>
                  <IonTextarea
                      name="ackInput"
                      value={emlak.aciklama}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, aciklama: e.detail.value! })
                      }
                  />
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonTextarea
                      name="ackInput"
                      value={emlak.aciklama}
                      onIonChange={(e) =>
                          setEmlak({ ...emlak, aciklama: e.detail.value! })
                      }
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="10" offset="0" sizeSm="4" offsetSm="1">
                <IonItem className="ion-text-end">
                  <IonLabel>Kimlik Fotokopisi Yükleme</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="6" offset="1" offsetSm="0">
                <IonItem>
                  <input
                      type="file"
                      id="kimlik-upload"
                      accept="image/*,application/pdf,.doc,.docx"
                      style={{display: "none"}}
                      onChange={async (_event: any) => {
                        const file = _event.target.files![0];
                        if (file.size > 5 * 1024 * 1024) {
                          setToastMessage("Dosya Boyutu 5 MB ile sınırlandırılmıştır. Lütfen daha küçük boyutta bir dosya seçiniz.");
                          return;
                        }
                        setKimlikFile(file);
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = function () {
                          const base64data = reader.result;
                          const belge = new BinaryData();
                          belge.data = base64data;
                          belge.fileName = file.name;
                          belge.contentType = file.type;
                          setEmlak({
                            ...emlak,
                            kimlikBelge: belge,
                          });
                        };
                      }}
                  />
                  <IonButton
                      slot="start"
                      size="default"
                      onClick={() =>
                          (document as any).getElementById("kimlik-upload").click()
                      }
                  >
                    Dosya Seç
                  </IonButton>
                  <IonText>{kimlikFile?.name}</IonText>
                  <IonButton
                      slot="end"
                      size="small"
                      color="light"
                      onClick={() => {
                        (document as any).getElementById("kimlik-upload").value =
                            "";
                        setKimlikFile(null);
                      }}
                  >
                    X
                  </IonButton>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="10" offset="0" sizeSm="4" offsetSm="1">
                <IonItem className="ion-text-end">
                  <IonLabel>Tapu Belgesi Yükleme</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="6" offset="1" offsetSm="0">
                <IonItem>
                  <input
                      type="file"
                      id="tapu-upload"
                      accept="image/*,application/pdf,.doc,.docx"
                      style={{display: "none"}}
                      onChange={async (_event: any) => {
                        const file = _event.target.files![0];
                        if (file.size > 5 * 1024 * 1024) {
                          setToastMessage("Dosya Boyutu 5 MB ile sınırlandırılmıştır. Lütfen daha küçük boyutta bir dosya seçiniz.");
                          return;
                        }
                        setTapuFile(file);
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = function () {
                          const base64data = reader.result;
                          const belge = new BinaryData();
                          belge.data = base64data;
                          belge.fileName = file.name;
                          belge.contentType = file.type;
                          setEmlak({
                            ...emlak,
                            tapuBelge: belge,
                          });
                        };
                      }}
                  />
                  <IonButton
                      slot="start"
                      size="default"
                      onClick={() =>
                          (document as any).getElementById("tapu-upload").click()
                      }
                  >
                    Dosya Seç
                  </IonButton>
                  <IonText>{tapuFile?.name}</IonText>
                  <IonButton
                      slot="end"
                      size="small"
                      color="light"
                      onClick={() => {
                        (document as any).getElementById("tapu-upload").value =
                            "";
                        setTapuFile(null);
                      }}
                  >
                    X
                  </IonButton>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="10" offset="0" sizeSm="4" offsetSm="1">
                <IonItem className="ion-text-end">
                  <IonLabel>Yapı Ruhsatı Yükleme</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="6" offset="1" offsetSm="0">
                <IonItem>
                  <input
                      type="file"
                      id="yapi-ruhsati-upload"
                      accept="image/*,application/pdf,.doc,.docx"
                      style={{display: "none"}}
                      onChange={async (_event: any) => {
                        const file = _event.target.files![0];
                        if (file.size > 5 * 1024 * 1024) {
                          setToastMessage("Dosya Boyutu 5 MB ile sınırlandırılmıştır. Lütfen daha küçük boyutta bir dosya seçiniz.");
                          return;
                        }
                        setYapiRuhsatiFile(file);
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = function () {
                          const base64data = reader.result;
                          const belge = new BinaryData();
                          belge.data = base64data;
                          belge.fileName = file.name;
                          belge.contentType = file.type;
                          setEmlak({
                            ...emlak,
                            yapiRuhsatBelge: belge,
                          });
                        };
                      }}
                  />
                  <IonButton
                      slot="start"
                      size="default"
                      onClick={() =>
                          (document as any).getElementById("yapi-ruhsati-upload").click()
                      }
                  >
                    Dosya Seç
                  </IonButton>
                  <IonText>{yapiRuhsatiFile?.name}</IonText>
                  <IonButton
                      slot="end"
                      size="small"
                      color="light"
                      onClick={() => {
                        (document as any).getElementById("yapi-ruhsati-upload").value =
                            "";
                        setYapiRuhsatiFile(null);
                      }}
                  >
                    X
                  </IonButton>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="10" offset="0" sizeSm="4" offsetSm="1">
                <IonItem className="ion-text-end">
                  <IonLabel>Yapı Kullanım İzin Belgesi  Yükleme</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="6" offset="1" offsetSm="0">
                <IonItem>
                  <input
                      type="file"
                      id="yapi-izin-upload"
                      accept="image/*,application/pdf,.doc,.docx"
                      style={{display: "none"}}
                      onChange={async (_event: any) => {
                        const file = _event.target.files![0];
                        if (file.size > 5 * 1024 * 1024) {
                          setToastMessage("Dosya Boyutu 5 MB ile sınırlandırılmıştır. Lütfen daha küçük boyutta bir dosya seçiniz.");
                          return;
                        }
                        setYapiKullanimIzinFile(file);
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = function () {
                          const base64data = reader.result;
                          const belge = new BinaryData();
                          belge.data = base64data;
                          belge.fileName = file.name;
                          belge.contentType = file.type;
                          setEmlak({
                            ...emlak,
                            yapiIzinBelge: belge,
                          });
                        };
                      }}
                  />
                  <IonButton
                      slot="start"
                      size="default"
                      onClick={() =>
                          (document as any).getElementById("yapi-izin-upload").click()
                      }
                  >
                    Dosya Seç
                  </IonButton>
                  <IonText>{yapiKullanimIzinFile?.name}</IonText>
                  <IonButton
                      slot="end"
                      size="small"
                      color="light"
                      onClick={() => {
                        (document as any).getElementById("yapi-izin-upload").value =
                            "";
                        setYapiKullanimIzinFile(null);
                      }}
                  >
                    X
                  </IonButton>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol style={{textAlign: "center"}}>
                <IonButton type="submit">Kaydet</IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default BinaBildirim;
